
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-around",
      function () {
        return require("private-next-pages/getting-around.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getting-around"])
      });
    }
  